"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _dayjs = _interopRequireDefault(require("dayjs"));
var Yup = _interopRequireWildcard(require("yup"));
var _FlightSearch = _interopRequireDefault(require("../FlightSearch"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FlightSearchForm = props => {
  const {
    submitFlightSearch,
    className,
    departureWindowStartTime,
    arrivalWindowEndTime,
    arrivalAirportCode,
    bookingID,
    currency,
    incomingStartDate,
    incomingEndDate,
    flightToDefault,
    labelFrom = 'From',
    labelTo = 'Flying to',
    labelButton = 'Search flights',
    noResultsErrorMessage = "We couldn't find the city/airport you entered",
    placeholderFrom = 'Enter airport name or code',
    minAvailableDate,
    maxAvailableDate,
    acOptions,
    menuItems
  } = props;
  const [departureAirport, setDepartureAirport] = (0, _react.useState)(null);
  const [flightDates, setFlightDates] = (0, _react.useState)(null);
  const guestMenuItems = menuItems.find(menuItem => menuItem.type === 'guestMenu');
  const [selectedGuests, setSelectedGuests] = (0, _react.useState)(guestMenuItems ? guestMenuItems.items : []);
  const getSelectedDates = value => {
    const {
      startDate,
      endDate
    } = value;
    const formattedStartDate = (0, _dayjs.default)(startDate).format('YYYY-MM-DD');
    const formattedEndDate = (0, _dayjs.default)(endDate).format('YYYY-MM-DD');
    setFlightDates({
      startDate: formattedStartDate,
      endDate: formattedEndDate
    });
  };
  (0, _react.useEffect)(() => {
    if (incomingStartDate && incomingEndDate) {
      setFlightDates({
        startDate: incomingStartDate,
        endDate: incomingEndDate
      });
    }
  }, [incomingStartDate, incomingEndDate]);
  const flightSearchSchema = Yup.object({
    departureAirportCode: Yup.string().required('requiere')
  });
  const initialValues = {
    departureWindowStartTime,
    arrivalWindowEndTime,
    arrivalAirportCode,
    bookingID,
    currency,
    departureAirportCode: departureAirport ? departureAirport.code : null,
    departureDate: flightDates ? flightDates.endDate : null,
    arrivalDate: flightDates ? flightDates.startDate : null,
    numberOfGuests: selectedGuests ? selectedGuests.length : null,
    guestIDs: selectedGuests ? selectedGuests.reduce((filtered, guest) => {
      if (guest.id && guest.selected && guest.requiresFlightTicket) {
        filtered.push(guest.id);
      }
      return filtered;
    }, []) : null
  };
  const formik = (0, _formik.useFormik)({
    enableReinitialize: true,
    initialValues,
    validationSchema: flightSearchSchema,
    onSubmit: values => {
      submitFlightSearch({
        variables: values
      });
    }
  });
  return /*#__PURE__*/_react.default.createElement("form", {
    className: className,
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_FlightSearch.default, {
    menuItems: menuItems,
    getSelectedDates: getSelectedDates,
    selectedDepartureAirport: value => setDepartureAirport(value),
    flightToDefault: flightToDefault,
    arrivalAirportCode: arrivalAirportCode,
    bookingID: bookingID,
    incomingStartDate: incomingStartDate,
    incomingEndDate: incomingEndDate,
    labelFrom: labelFrom,
    labelTo: labelTo,
    labelButton: labelButton,
    noResultsErrorMessage: noResultsErrorMessage,
    placeholderFrom: placeholderFrom,
    minAvailableDate: minAvailableDate,
    maxAvailableDate: maxAvailableDate,
    arrivalDate: true,
    acOptions: acOptions,
    onSelectedGuests: value => setSelectedGuests(value),
    selectedGuests: selectedGuests
  }));
};
var _default = exports.default = FlightSearchForm;